import { useId } from 'react'

export default function useGradientId() {
  const id = `gradient-${useId()}`

  const gradientReference = `url(#${id})`

  return [id, gradientReference]
}
